import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function MobileMenu({ isOpen, onClose }) {
    const [activeMenu, setActiveMenu] = useState(null);
    const menuRefs = useRef({});
    const { pathname } = useLocation();

    const isHomeActive = pathname === '/';
    const isAboutActive = pathname === '/about';
    const isDestinationActive = pathname.startsWith('/destination');
    const isTourActive = pathname.startsWith('/tour');
    const isContactActive = pathname === '/contact';

    // Toggle dropdown menu
    const toggleMenu = (index) => {
        if (index !== 6) {
            setActiveMenu(activeMenu === index ? null : index);
        }
    };

    // Apply height animation when activeMenu changes
    useEffect(() => {
        Object.keys(menuRefs.current).forEach((key) => {
            const submenu = menuRefs.current[key];
            if (submenu) {
                submenu.style.height = activeMenu === Number(key) ? `${submenu.scrollHeight}px` : "0px";
            }
        });
    }, [activeMenu]);

    return (
        <div className={`th-menu-wrapper onepage-nav ${isOpen ? "th-body-visible" : ""}`}
            style={{ visibility: isOpen ? "visible" : "hidden" }}>

            <div className="th-menu-area text-center">
                <button className="th-menu-toggle" onClick={onClose} aria-label="Close">
                    <i className="fal fa-times" />
                </button>

                <div className="mobile-logo">
                    <Link to="/">
                        <img src="/assets/img/primary-logo.png" alt="Himolan Peak Adventures" />
                    </Link>
                </div>

                <div className="th-mobile-menu">
                    <ul>
                        {/* Home */}
                        <li className={isHomeActive ? 'th-active' : ''}>
                            <Link to="/">Home</Link>
                        </li>

                        {/* About Us */}
                        <li className={isAboutActive ? 'th-active' : ''}>
                            <Link to="/about">About Us</Link>
                        </li>

                        {/* Destination */}
                        <li className={isDestinationActive ? 'th-active' : ''}>
                            <Link to="/destination">Destination</Link>
                        </li>

                        {/* Our Tour */}
                        <li className={`menu-item-has-children th-item-has-children ${isTourActive || activeMenu === 5 ? "th-active" : ""}`}>
                            <Link to="#" onClick={() => toggleMenu(5)}>Our Tour</Link>
                            <ul
                                ref={(el) => (menuRefs.current[5] = el)}
                                className="th-submenu"
                                style={{ height: "0px", overflow: "hidden", transition: "height 0.3s ease-in-out" }}
                            >
                                <li><Link to="/tour">All Tours</Link></li>
                                <li><Link to="/tour/skardu-blossom-tour">Skardu Blossom Tour (By Road)</Link></li>
                                <li><Link to="/tour/skardu-tour-by-air">Skardu Tour (By Air)</Link></li>
                                <li><Link to="/tour/skardu-honeymoon-special">Skardu Honeymoon Special</Link></li>
                                <li><Link to="/tour/hunza-cherry-blossom-tour">Hunza Cherry Blossom Tour</Link></li>
                                <li><Link to="/tour/hunza-nagar-naltar-tour">Hunza, Nagar & Naltar (By Road)</Link></li>
                                <li><Link to="/tour/fairy-meadows-hunza-tour">Fairy Meadows & Hunza Tour</Link></li>
                            </ul>
                        </li>

                        {/* Contact */}
                        <li className={isContactActive ? 'th-active' : ''}>
                            <Link to="/contact">Contact Us</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default MobileMenu;

